/* SessionStatusIcon.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._39xV02xpxF%7Bwidth%3A9pt%7D%0A._0jFU0VxpxF%7Bheight%3A9pt%7D%0A._3YEZNOdnbC%7Bflex-shrink%3A0%7D%0A._39xV02ey7F%7Bwidth%3A1pc%7D%0A._0jFU0Vey7F%7Bheight%3A1pc%7D");






import React from 'react';
import QuestionCircleFilledIcon from '@atlaskit/icon-lab/core/question-circle-filled';
import QuestionCircleIcon from '@atlaskit/icon/core/question-circle';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Flex } from '@atlaskit/primitives/compiled/flex';
export type SessionStatus = 'needs-input';
export type SessionStatusIconSize = 12 | 16;
export type SessionStatusIconProps = {
  status: SessionStatus;
  label?: string;
  /** CSS color for the filled icon. Defaults to the blue brand icon token. */
  color?: string;
  /** Visual size for the icon. Defaults to 12. */
  iconSize?: SessionStatusIconSize;
  /** The outlined treatment is used when the icon appears inside a status badge. */
  appearance?: 'filled' | 'outlined';
  testId?: string;
};
const iconSizeStyles = {
  12: "_4bt5LAnQyn _2WAcuGnQyn _39xV02xpxF _0jFU0VxpxF _3YEZNOdnbC",
  16: "_4bt5LAnQyn _2WAcuGnQyn _39xV02ey7F _0jFU0Vey7F _3YEZNOdnbC"
};
export const SessionStatusIcon = ({
  status,
  label = '',
  color = "var(--ds-icon-brand, #1868DB)",
  iconSize = 12,
  appearance = 'filled',
  testId
}: SessionStatusIconProps): React.JSX.Element | null => {
  if (status === 'needs-input') {
    return <Box as="span" testId={testId} style={{
      color
    }}>
				<Flex as="span" xcss={iconSizeStyles[iconSize]} alignItems="center" justifyContent="center">
					{appearance === 'outlined' ? <QuestionCircleIcon label={label} size="small" /> : <QuestionCircleFilledIcon label={label} size="small" />}
				</Flex>
			</Box>;
  }
  return null;
};